// extracted by mini-css-extract-plugin
export default {"main":"PageTypeB_main__06LLf","wrapper":"PageTypeB_wrapper__qH6bU","textWrapper":"PageTypeB_textWrapper__Drgbe","title":"PageTypeB_title__Xzl6M","text":"PageTypeB_text__WxM8N"};